<template lang="html">
  <div class="menu-container" :class=[className] v-if="showMenu">
    <div v-for="(group, index) in links" :key="index">
      <div
        :class="['menu-link bgap-8', isSelected(link) && 'selected', link.mobileOnly && 'mobile-only']"
        v-for="link in group"
        @click="() => switchToLink(link)"
        :key="link.text"
      >
        <span class="link-gray body-14">{{link.text}}</span>
      </div>
      <hr class="menu-group-divider" v-if="index !== links.length - 1" />
    </div>
  </div>
</template>

<script>
import EventBus from 'src/components/EventBus.js'
import _ from 'lodash'
import qs from 'qs'
export default {
  props: ['currentMenu', 'subMenu', 'className'],
  data() {
    return {
      links: _.clone(this.commonMenu),
      expand: false,
    }
  },
  methods: {
    switchToLink(link) {
      if(link.href.startsWith('http')) {
        window.open(link.href, "_blank")
      } else {
        if(!this.isSelected(link)) this.$router.push(link.href).catch(() => {})
      }
    },
    isSelected(link) {
      return link.text == this.currentMenu || link.text == this.subMenu;
    },
    assignUserData(user) {
      var links = _.clone(this.commonMenu)

      if(user.is_super_admin) {
        links.push(this.superAdminMenu)
      }

      if(user.is_media_admin) {
        links.push(this.mediaAdminMenu)
      }

      if(user.is_vendor) {
        links.push(this.vendorMenu)
      }

      links.push(_.map(user.ownerships, (product) => {
        return {
          text: product.product,
          href: `/dashboard/ownerships?${qs.stringify({ productName: product.product})}`
        }
      }))

      if(user.has_dev_portal_subscription) {
        links.push(this.devPortalMenu)
      }

      this.links = _.filter(links, _.size)
    },
    addMyProjectsLinks() {
      this.links = [...this.links, this.myProjectsMenu]
    }
  },
  created() {
    EventBus.$on('user-fetched', this.assignUserData)
    EventBus.$on('user-has-projects', this.addMyProjectsLinks)
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignUserData)
    EventBus.$off('user-has-projects', this.addMyProjectsLinks)
  },
  mounted() {
    this.links = _.clone(this.commonMenu)
  },
  computed: {
    showMenu() {
      if (this.links && this.links.length == 1 && this.links[0].length == 1) {
        return false
      }
      return true
    },
    commonMenu() {
      return [[
        { text: 'Account Overview', href: '/dashboard/account_overview' },
        { text: 'Profile', href: '/dashboard/profile' },
        { text: 'Change Password', href: '/dashboard/change_password' },
        { text: 'Notifications', href: '/dashboard/notifications' },
      ]]
    },
    vendorMenu() {
      return [
        { text: 'Symbium Build', href: '/dashboard/build' },
        { text: 'Analytics', href: '/dashboard/analytics' },
        { text: 'Your Listings', href: '/dashboard/listings' }
      ]
    },
    superAdminMenu() {
      return [
        { text: 'Approve Vendors', href: '/dashboard/vendors' },
        { text: 'Symbium Vendors', href: '/dashboard/vendors_managment' },
        { text: 'Build+ Subscriptions', href: '/dashboard/buildplus_management' },
        { text: 'Plancheck Subscriptions', href: '/dashboard/plancheck_management' },
        { text: 'Post Management', href: '/dashboard/post_management' },
        { text: 'City Page Management', href: '/dashboard/city_page_management' },
      ]
    },
    mediaAdminMenu() {
      return [
        { text: 'Post Management', href: '/dashboard/post_management' }
      ]
    },
    myProjectsMenu() {
      return [
        { text: 'My Projects', href: `${process.env.VUE_APP_HOME_PAGE}/projects/?class=unit` }
      ]
    },
    devPortalMenu() {
      return [
        { text: 'Developer Profile', href: `${process.env.VUE_APP_DEV_PORTAL}/settings/account` }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-container {
  min-width: 185px;
  max-width: 185px;
  font-size: 16px;
  line-height: 24px;
  margin-right: 24px;
}

.menu-group-divider {
  border-top: 1px solid var(--gray-divider);
  width: 100%;
  margin: 16px 0;
}

.menu-link.mobile-only + .menu-group-divider {
  display: none;
}

.link-gray {
  font-weight: 400;

  &:hover {
    text-decoration: none;
    font-weight: 500;
  }
}

.selected{
  .link-gray {
    color: var(--black);
    font-weight: 500;
  }
}

@media screen and (max-width: 768px) {
  .sub-menu {
    padding: 0 24px;
    min-width: 100%;
    max-width: 100%;

    .link-gray {
      color: var(--black);
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
      letter-spacing: 0.07px;
    }

    .menu-link {
      margin: 0;
      padding: 24px 0 0;
      color: var(--purple);

      &:hover, &.selected {
        text-decoration: underline;
      }
    }

    .menu-group-divider {
      border: none;
      margin: 0;
      height: 24px;
    }

    .menu-link.mobile-only + .menu-group-divider {
      display: block;
    }

  }
}
</style>
